function priceSelect() {
  return [
    { text: '1.000.000đ', value: 1000000 },
    { text: '2.000.000đ', value: 2000000 },
    { text: '5.000.000đ', value: 5000000 },
    { text: '10.000.000đ', value: 10000000 },
    { text: '20.000.000đ', value: 20000000 },
    { text: '50.000.000đ', value: 50000000 },
    { text: '100.000.000đ', value: 100000000 },
    { text: '200.000.000đ', value: 200000000 },
    { text: '500.000.000đ', value: 500000000 },
    { text: '1.000.000.000đ', value: 1000000000 }
  ]
}
function deliveryStatusSelect() {
  return [
    { label: 'Tất cả', value: '', color: 'primary' },
    { label: 'Chưa có lịch', value: 'noSchedule', color: 'error' },
    { label: 'Đang giao', value: 'delivering', color: 'warning' },
    { label: 'Chưa giao đủ', value: 'incompleteDelivery', color: 'error' },
    { label: 'Đã giao đủ', value: 'completeDelivery', color: 'success' },
    { label: 'Gửi kho hãng', value: 'toInventory', color: 'primary' }
  ]
}
function orderStatusSelect() {
  return [
    { label: 'Tất cả', value: '', color: 'primary' },
    { label: 'Đang tạo', value: 'created', color: 'warning' },
    { label: 'Chờ duyệt', value: 'notApproved', color: 'error' },
    { label: 'Đã duyệt', value: 'approved', color: 'success' },
    { label: 'Đã gửi hãng', value: 'supplierSent', color: 'success' }
  ]
}
function auditProductSelect() {
  return [
    { label: 'Tất cả', value: '', color: 'primary' },
    { label: 'Đang giao', value: 'delivering', color: 'warning' },
    { label: 'Chưa giao đủ', value: 'incompleteDelivery', color: 'error' },
    { label: 'Đã giao đủ', value: 'completeDelivery', color: 'success' },
  ]
}

function statusProductModel() {
  return [
    { name: 'Kinh doanh', id: 'active' },
    { name: 'Bỏ mẫu', id: 'inactive' },
    { name: 'Đã bị xóa', id: 'deleted' },
  ]
}
function advantageProductModel() {
  return [
    { name: 'Hàng phổ thông', id: 'typical' },
    { name: 'Độc quyền ưu thế', id: 'exclusiveAdvance' },
    { name: 'Độc quyền sỉ', id: 'exclusiveMass' },
    { name: 'Độc quyền toàn phần', id: 'exclusiveAll' },
  ]
}
function getVat() {
  return [
    { name: '8%', id: 8 },
    { name: '10%', id: 10 },
  ]
}
export {
  priceSelect,
  deliveryStatusSelect,
  orderStatusSelect,
  auditProductSelect,
  statusProductModel,
  advantageProductModel,
  getVat
}
